import { z } from 'zod';

export const ActivateRequest = z.object({
  /**
   * Код активации из офиса.
   *
   * Форма НЕ задаётся здесь жёстко. Коды выдаются из трёх мест —
   * сид, панель платформы, экран устройств — и правила там разные.
   * Строгий шаблон дважды приводил к отказу в активации по совершенно
   * верному коду: сервер отвергал его до того, как заглянуть в базу.
   *
   * Проверяем только очевидное: непустая строка разумной длины.
   * Существует код или нет — знает база, и это её ответ.
   */
  code: z.string().trim().min(4).max(40),
});
export type ActivateRequest = z.infer<typeof ActivateRequest>;

export const ActivateResponse = z.object({
  deviceKey: z.string(),
  terminalId: z.string(),
  locationId: z.string(),
  locationName: z.string(),
});
export type ActivateResponse = z.infer<typeof ActivateResponse>;

/** Кассы точки со статусом связи — для офиса. */
export const TerminalRow = z.object({
  terminalId: z.string(),
  name: z.string(),
  activated: z.boolean(),
  lastSeenAt: z.string().datetime().nullable(),
});
export const TerminalsList = z.object({ rows: z.array(TerminalRow) });
export type TerminalsList = z.infer<typeof TerminalsList>;
